// @file Checks if browser extensions/add-ons are present
import { browserIs } from 'bits/browser'
export const PROD_CHROME_EXTENSION_ID = 'kcljbbiddpoeaknnjaminoceoojdbikp'
export const PROD_EDGE_EXTENSION_ID = 'chdcjmemggihkfoncbakagfcpmbgdnda'
export const DEV_CHROME_EXTENSION_ID = 'knehpeaddanfilncdljjklcjjbinkopl'

// also checks for edge too since edge is chromium based
export const checkForPadletMiniChromeExtensionForId = async function (extensionId: string): Promise<boolean> {
  const scriptElemId = `test-installed-chrome-extension-${extensionId}`

  // Ensure that the check is run afresh
  const existingScript = document.getElementById(scriptElemId)
  if (existingScript != null) document.body.removeChild(existingScript)

  const scriptCheckPromise: Promise<boolean> = new Promise((resolve) => {
    const script = document.createElement('script')
    script.id = scriptElemId
    script.onload = (): void => {
      resolve(true)
    }
    script.onerror = (): void => {
      resolve(false)
    }
    script.src = `chrome-extension://${extensionId}/screenshare.js`
    document.body.appendChild(script)
  })

  return await scriptCheckPromise
}

// also checks for edge too since edge is chromium based
export async function checkForPadletMiniChromeExtension(): Promise<boolean> {
  if (!browserIs('chromiumBased')) return false

  // chrome and edge use same development extension id
  const chromeExtensionId = process.env.NODE_ENV === 'production' ? PROD_CHROME_EXTENSION_ID : DEV_CHROME_EXTENSION_ID
  const edgeExtensionId = process.env.NODE_ENV === 'production' ? PROD_EDGE_EXTENSION_ID : DEV_CHROME_EXTENSION_ID

  return (
    (await checkForPadletMiniChromeExtensionForId(chromeExtensionId)) ||
    (await checkForPadletMiniChromeExtensionForId(edgeExtensionId))
  )
}
